import { makeAutoObservable, runInAction } from 'mobx'
import { history } from '../history'
import agent from '../api/agent'
import { User, UserFormValues } from '../models/user'
import { getRootStore } from './rootStore'

export default class UserStore {
  user: User | null = null

  constructor () {
    makeAutoObservable(this)
  }

  get isLoggedIn () {
    return !!this.user
  }

  /** Dependable flag for admin-only UI and behavior. Use in components to show/hide admin actions. */
  get isAdmin () {
    return this.user?.isAdmin === true
  }

  /** True when the current user is a moderator (can access moderation dashboard). */
  get isModerator () {
    return this.user?.isModerator === true
  }

  login = async (creds: UserFormValues) => {
    try {
      const user = await agent.Account.login(creds)
      getRootStore().commonStore.setToken(user.token)
      runInAction(() => (this.user = user))
      getRootStore().notificationStore.startPolling()
      void getRootStore().commonStore.loadPendingLegalAcceptances()
      history.push('/blog')
      getRootStore().modalStore.closeModal()
    } catch (error) {
      throw error
    }
  }

  logout = () => {
    getRootStore().notificationStore.stopPolling()
    getRootStore().commonStore.setToken(null)
    getRootStore().commonStore.setPendingLegalAcceptances([])
    window.localStorage.removeItem('jwt')
    this.user = null
    history.push('/')
  }

  getUser = async () => {
    try {
      const user = await agent.Account.current()
      runInAction(() => (this.user = user))
      getRootStore().notificationStore.startPolling()
      void getRootStore().commonStore.loadPendingLegalAcceptances()
    } catch (error: any) {
      if (error?.response?.status === 401) {
        getRootStore().commonStore.setPendingLegalAcceptances([])
        runInAction(() => {
          this.user = null
          getRootStore().commonStore.setToken(null)
        })
      }
      console.log(error)
    }
  }

  register = async (creds: UserFormValues) => {
    try {
      const user = await agent.Account.register(creds)
      getRootStore().commonStore.setToken(user.token)
      runInAction(() => (this.user = user))
      getRootStore().notificationStore.startPolling()
      void getRootStore().commonStore.loadPendingLegalAcceptances()
      history.push('/blog')
      getRootStore().modalStore.closeModal()
    } catch (error) {
      throw error
    }
  }

  setImage = (image: string) => {
    if (this.user) this.user.image = image
  }

  setDisplayName = (displayName: string) => {
    if (this.user) this.user.displayName = displayName
  }
}
